import { WIDGET_ACTIONS } from './types';
import IPC from '../../../helpers/ipc';
import Logger from '../../../../common/logger';
import store from '../../../helpers/store';
import { getViewAndMode } from '../../views/helpers';
import * as MainActions from '../../main/actions';
import { LAYERS } from '../types';
import * as Router from './router';
import { COOKIES } from './types';
import { VIEW_MODES } from '../../views/types';
import { getWidgetDisplay } from './helpers';
import * as ConfigurationActions from '../../../helpers/configuration/actions';
import { DISPLAY } from '../../main/types';
import { APIMode, APISubmode } from '../../../api/types';
import ChatAPI from '../../views/chat/ChatAPI';
import { encodeMessage } from '../../../genesys/apiv2';
import Tracker from '../../../genesys/tracker';
import * as Actions from './actions'; // import module into itself

export const onInit = () => {
    const state = store.getState();
    store.dispatch({
        type: WIDGET_ACTIONS.INIT,
        data: {
            isInitView: state.widget.isInitView,
            currentView: state.widget.currentView,
            currentMode: state.widget.currentMode,
            widgetDisplay: state.widget.widgetDisplay,
            width: state.widget.width,
            height: state.widget.height,
            isUsabilaCookiePresent: state.widget.isUsabilaCookiePresent
        }
    });
};

export const onOpen = () => {
    const state = store.getState();
    const { view, mode } = getViewAndMode(state.config.widget.defaultView);

    if (!view || !mode) {
        Logger.error('WidgetActions.onOpen: no view nor mode');
        return;
    }

    store.dispatch({
        type: WIDGET_ACTIONS.OPEN,
        data: {
            view,
            mode,
            widgetDisplay: getWidgetDisplay(view, mode)
        }
    });
};

export const onSwitchView = ({ view, mode }) => {
    const state = store.getState();
    view = view ? Router.route(view) : state.widget.currentView;
    mode = mode ? mode : VIEW_MODES.MAXIMIZED;

    store.dispatch({
        type: WIDGET_ACTIONS.SWITCH,
        data: {
            view: view,
            mode: mode,
            widgetDisplay: getWidgetDisplay(view, mode)
        }
    });
};

export const onClose = (source, forceClose = false, reason = undefined) => {
    if (source) {
        Logger.log(WIDGET_ACTIONS.CLOSE + ': ' + source);
    }
    const view = Router.route(null);
    Logger.log(
        `WidgetActions.onClose: [nextView=${view}, forceClose=${forceClose}, reason=${reason}]`
    );

    if (view && !forceClose) {
        onSwitchView({ view: view });
    } else {
        MainActions.onClose({
            layer: LAYERS.WIDGET,
            reason: reason
        });
        store.dispatch({
            type: WIDGET_ACTIONS.CLOSE
        });
        ConfigurationActions.resetWidgetConfig();
    }
};

export const onPreloaderClose = () => {
    store.dispatch({
        type: WIDGET_ACTIONS.SWITCH,
        data: {
            view: 'PRELOADER_CLOSING',
            mode: VIEW_MODES.MAXIMIZED,
            widgetDisplay: DISPLAY.NONE
        }
    });
};

export const onParentResize = () => {
    const widgetDisplay = getWidgetDisplay();

    MainActions.updateMainLayer({
        layer: LAYERS.WIDGET,
        iFrameMode: widgetDisplay
    });

    store.dispatch({
        type: WIDGET_ACTIONS.RESIZE,
        data: {
            widgetDisplay: widgetDisplay
        }
    });
};

export const onMinimize = () => {
    Tracker.sendEvent('widgetMinimized');
    IPC.sendEvent(WIDGET_ACTIONS.MINIMIZED);
    onSwitchView({ mode: VIEW_MODES.MINIMIZED });
};

export const onMaximize = () => {
    Tracker.sendEvent('widgetMaximized');
    IPC.sendEvent(WIDGET_ACTIONS.MAXIMIZED);
    onSwitchView({ mode: VIEW_MODES.MAXIMIZED });
};

export const onPopup = () => {
    onSwitchView({ mode: VIEW_MODES.POPUP });
};

export const inviteResultSend = () => {
    store.dispatch({
        type: WIDGET_ACTIONS.INVITE_RESULT_SEND
    });
};

export const checkUsabilaCookie = (isPresent) => {
    store.dispatch({
        type: COOKIES.CHECK_USABILA,
        data: {
            isPresent: isPresent
        }
    });
};

export const sendOrderIdToChat = (orderId) => {
    const customMessage = {
        type: 'message',
        message: `Użytkownik złożył zamówienie o numerze: ${orderId}`,
        source: 'bot',
        username: 'Bot',
        payload: {
            orderId: orderId
        }
    };

    const state = store.getState();
    if (state.chat.sessionActive && state.chat.mode === APIMode.CHAT) {
        const api = ChatAPI.get();
        if (api) {
            api.sendUserData({ web_order_id: orderId }, () => {
                api.sendMessage(encodeMessage(customMessage));
            });
        }
    }
};

export const sendUserMOLoggedInToChat = () => {
    Logger.log('sendUserMOLoggedInToChat: start');
    const state = store.getState();

    if (!state.chat.monitorForUserMOLogin) {
        Logger.log('sendUserMOLoggedInToChat: no monitoring for user MO login');
        return;
    }

    Tracker.sendEvent('widgetUserMOLoginCorrectUrlsAndFlag');

    if (
        !state.chat.sessionActive ||
        state.chat.mode !== APIMode.CHAT ||
        (state.chat.submode !== APISubmode.MAX && state.chat.agent.name !== 'wirtualny konsultant')
    ) {
        Logger.log('sendUserMOLoggedInToChat: no active session/chat/max');
        Tracker.sendEvent('widgetUserMOLoginNoActiveSession');
        return;
    }

    const api = ChatAPI.get();
    if (api) {
        Logger.log('sendUserMOLoggedInToChat: sending user data through API');
        api.sendUserData({ userMOLoggedIn: 'yes' });
        Tracker.sendEvent('widgetUserMOLoginUserDataSet');
        setTimeout(Actions.onMaximize(), 0);
    } else {
        Logger.log('sendUserMOLoggedInToChat: could not get API object');
        Tracker.sendEvent('widgetUserMOLoginNoAPIObject');
    }
};
